import { useLayoutEffect, useState } from 'react'

/* eslint-disable */

const animations = [
  {
    duration: 6000,
    direction: 'reverse',
  },
  {
    duration: 4000,
    direction: 'normal',
  },
  {
    duration: 3000,
    direction: 'reverse',
  },
  {
    duration: 2000,
    direction: 'normal',
  },
]

export function usePreloader() {
  const [loaded, setLoaded] = useState(false)

  useLayoutEffect(() => {
    if (typeof window === undefined) return

    document.body.classList.add('loaded')
    setLoaded(Boolean(localStorage?.getItem('hasLoaded')))
  }, [])

  useLayoutEffect(() => {
    let isPageLoaded = false
    let isTimeExpired = false

    const circles = document.querySelectorAll('.circle')
    const currentAnimations = Array.from(circles).map((circle, index) => {
      const computedStyle = getComputedStyle(circle)
      const computedTransform = computedStyle.transform
      let currentAngle = 0

      if (computedTransform !== 'none') {
        const values = computedTransform.match(/matrix\(([^)]+)\)/)
        if (values) {
          const angles = Math.atan2(values[1].split(',')[1], values[1].split(',')[0]) * (180 / Math.PI)
          currentAngle = (angles + 360) % 360
        }
      }

      return circle.animate(
        [{ transform: `rotate(${currentAngle}deg)` }, { transform: `rotate(${currentAngle + 360}deg)` }],
        {
          easing: 'linear',
          direction: animations[index].direction,
          duration: animations[index].duration,
          iterations: Infinity,
        }
      )
    })

    function onLoaded() {
      setLoaded(true)
      localStorage.setItem('hasLoaded', 'true')
      document.body.classList.add('loaded')

      const startValue = 0.999
      const endValue = 0.021

      animate({
        draw(progress) {
          const currentValue = roundToDecimals(startValue + (endValue - startValue) * progress, 4)

          currentAnimations.forEach(animation => {
            animation.playbackRate = currentValue
          })
        },
        duration: 1286,
      })

      document.body.removeAttribute('style')
    }

    if (loaded) {
      onLoaded()
    } else {
      document.body.style.overflow = 'hidden'

      const checkLoaded = () => {
        if (isTimeExpired && isTimeExpired) onLoaded()
      }

      const onLoad = () => {
        isPageLoaded = true
        checkLoaded()
      }

      window.addEventListener('load', onLoad)
      setTimeout(() => {
        isTimeExpired = true
        checkLoaded()
      }, 1400)

      return () => window.removeEventListener('load', onLoad)
    }
  }, [])

  return { loaded }
}

function roundToDecimals(num, decimals) {
  if (isNaN(num) || isNaN(decimals)) {
    throw new Error('Параметры должны быть числами.')
  }
  if (decimals < 0) {
    throw new Error('Количество знаков после запятой не может быть отрицательным.')
  }
  const factor = Math.pow(10, decimals)
  return Math.round(num * factor) / factor
}

export function linear(timeFraction) {
  return timeFraction
}

function easeOut(timeFraction) {
  return Math.sin(Math.acos(1 - timeFraction))
}

export function animate({ timing = easeOut, draw, duration }) {
  let start = performance.now()

  requestAnimationFrame(function animate(time) {
    // timeFraction изменяется от 0 до 1
    let timeFraction = (time - start) / duration
    if (timeFraction < 0) timeFraction = 0
    if (timeFraction > 1) timeFraction = 1

    // вычисление текущего состояния анимации
    let progress = timing(timeFraction)

    draw(progress) // отрисовать её

    if (timeFraction < 1) {
      requestAnimationFrame(animate)
    }
  })
}
